import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { opacityFadeIn } from '@hiptraveler/animations';
import { ListView } from '../common';

@Component({
  selector: 'not-included',
  templateUrl: './not-included.component.html',
  styleUrls: ['./not-included.component.scss'],
  animations: [ opacityFadeIn() ]
})
export class NotIncludedComponent extends ListView implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public form: FormGroup
  ) {
    super()
  }

  ngOnInit(): void {
    this.items = (this.form.get('exclusions') as FormArray).value;
  }

  get formArray(): FormArray {
    return this.form.get('exclusions') as FormArray;
  }

}
